import { serverFetch as baseServerFetch } from '@core/server';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const warehouseCode = process.env.REACT_APP_WHS_CODE;

export async function serverFetch(address, options, signal) {
    return baseServerFetch(apiBaseUrl, warehouseCode, address, options, signal);
}
